<style scoped>
.back-btn {
  position: absolute;
  display: inline-block;
  top: 10px;
  left: 10px;
}
</style>

<template>
  <v-tooltip right>
    <template v-slot:activator="{ on, attrs }">
      <div class="back-btn cursor-pointer">
        <v-btn icon :to="{ name: 'LoginView' }" v-bind="attrs" v-on="on">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
    </template>
    <span>Back to Login</span>
  </v-tooltip>
</template>

<script>
export default {};
</script>
